import React from "react";
import {
  Box,
  Stack,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
  Button,
} from "@mui/material";
import { CurrencyConverter, IMAGES, WEB_COLORS } from "@/lib/constants";
import Image from "next/image";
import { InfoOutlined } from "@mui/icons-material";
import { ButtonComponent } from "@/components";

const UpgradeOfferUpto7 = ({ handleContinueWithUpgrade }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isBelowMd = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Stack
      sx={{
        position: "relative",
        width: "100%",
        borderRadius: { xs: "8px", md: "10px" },
        background: `linear-gradient(to bottom right, #CEE9B7, #F0EED7, #FFFFFF)`,
        minWidth: "290px",
        cursor: "pointer",
      }}
      onClick={() => handleContinueWithUpgrade()}
    >
      <Box
        sx={{
          position: "absolute",
          top: 4,
          left: { xs: -28, sm: -40 },
          zIndex: 2,
          width: { xs: 135, sm: 195 },
          height: "auto",
        }}
      >
        <Image
          src={IMAGES.exclusiveOfferLabel}
          alt="Exclusive Upgrade"
          width={isMobile ? 150 : 210}
          height={isMobile ? 32 : 44}
          style={{
            display: "block",
          }}
        />
      </Box>
      <Grid
        container
        justifyContent={"space-between"}
        paddingTop={{ xs: "10px", sm: "20px" }}
        paddingLeft={{ xs: "12px", sm: "25px" }}
        sx={{
          position: "relative",
          mt: { xs: 2 },
          mb: { md: 0, xs: 1 },
          cursor: "pointer",
        }}
        onClick={() => handleContinueWithUpgrade()}
      >
        <Grid item xs={8} md={8}>
          <Stack flexDirection={"row"} color={"#fff"}>
            <Box>
              <Typography
                fontWeight={{ xs: 400 }}
                fontSize={{ xs: "12px", sm: "16px" }}
                color={"#005B00"}
              >
                Great News!{" "}
                <Typography
                  display={"inline"}
                  fontWeight={{ xs: 400 }}
                  color={"#407168"}
                  fontSize={{ xs: "12px", sm: "16px" }}
                >
                  You're Eligible for a Higher offer upto{" "}
                </Typography>
              </Typography>
              <Typography
                fontWeight={{ xs: 700, sm: 500 }}
                fontSize={{ xs: "28px", sm: "48px" }}
                color={WEB_COLORS.darkTeal}
              >
                {CurrencyConverter(700000)}
              </Typography>
            </Box>
          </Stack>

          <ButtonComponent
            buttonStyle={{ padding: { xs: 1 } }}
            stackWidth={isMobile ? "126px" : "179px"}
            onClick={() => handleContinueWithUpgrade()}
          >
            Resume Journey
          </ButtonComponent>
        </Grid>

        <Grid
          item
          xs={3}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Image
            src={IMAGES.upgradeOfferCoin}
            alt="Money Sack"
            width={isMobile ? 104 : 150}
          />
        </Grid>
      </Grid>
      <Stack
        backgroundColor={"#E5F7E5"}
        alignItems={"center"}
        width="100%"
        sx={{
          borderEndStartRadius: "12px",
          borderEndEndRadius: "12px",
        }}
      >
        <Box
          mt={1}
          display={"flex"}
          flexDirection={"row"}
          gap={0.5}
          alignItems={"center"}
          mb={1}
        >
          <InfoOutlined
            color="#407168"
            sx={{
              color: "#407168",
              fontSize: { xs: "12px", sm: "14px" },
            }}
          />

          <Typography
            fontWeight={350}
            fontSize={{ xs: "8px", sm: "16px" }}
            color={"#407168"}
          >
            6 months of banking required.
          </Typography>
        </Box>
      </Stack>
    </Stack>
  );
};

export default UpgradeOfferUpto7;
